// extracted by mini-css-extract-plugin
module.exports = {"notification":"GoSocial_notification__uPiCL","count":"GoSocial_count__3UCGd"};